module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_3-c70ff51b9c14c6dc8e14bb4e21f650b4.png";